export const getLevelShortName = function (levelCode: string) {
  switch (Number(levelCode)) {
    case 1:
      return 'TB';
    case 2:
      return 'HB';
    case 3:
      return 'Int';
    default:
      return levelCode;
  }
};

export const getRoleTag = function (teacherRole: string) {
  switch (teacherRole) {
    case 'ROLE_TEACHER_ADMIN':
      return 'SM';
    case 'ROLE_MONITOR':
      return 'M';
    case 'ROLE_TEACHER':
      return 'T';
    default:
      return teacherRole;
  }
};
